<app-banner></app-banner>
<app-carousel></app-carousel>
<app-course-slider></app-course-slider>
<app-extras></app-extras>